module.exports = __webpack_public_path__ + "img/9.0f4b0170.png";